<template>
  <div
    class="form-input"
    :class="classObject"
  >
    <label
      :for="formID"
      class="form-input__label"
      :class="{ 'sr-only': hideLabel }"
    >
      <slot />
    </label>
    <span
      v-show="error"
      class="form-input__error"
    >{{ error }}</span>
    <input
      :id="formID"
      ref="input"
      class="form-input__input form-input__input--date"
      type="date"
      :name="name"
      :value="value"
      :disabled="disabled"
      :placeholder="placeholder"
      @change="onChange"
    >
  </div>
</template>

<script>
import flatpickr from 'flatpickr'
import { German } from 'flatpickr/dist/l10n/de.js'

import formFieldsMixin from '../mixins/formFields'

export default {
  name: 'CFormDate',

  mixins: [formFieldsMixin],

  props: {
    color: {
      type: String,
      default: undefined
    },
    disabled: Boolean,
    error: {
      type: String,
      default: undefined
    },
    hideLabel: Boolean,
    id: {
      type: String,
      default: undefined
    },
    inline: Boolean,
    inlineLabel: Boolean,
    name: {
      type: String,
      default: undefined
    },
    maxDate: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    value: {
      type: String,
      default: undefined
    }
  },

  emits: ['change'],

  data () {
    return {
      flatpickr: null
    }
  },

  watch: {
    value (newValue) {
      if (this.flatpickr) {
        this.flatpickr.setDate(newValue)
      }
    }
  },

  mounted () {
    this.initDatepicker()
  },

  updated () {
    if (!this.flatpickr && !this.disabled) {
      this.initDatepicker()
    } else if (this.flatpickr && this.disabled) {
      this.flatpickr.destroy()
      this.flatpickr = null
    }
  },

  destroyed () {
    if (this.flatpickr) {
      this.flatpickr.destroy()
      this.flatpickr = null
    }
  },

  methods: {
    onChange (event) {
      this.$emit('change', event.target.value)
    },
    initDatepicker () {
      if (this.disabled) {
        return
      }

      const localization = {
        en: {
          altFormat: 'j F Y'
        },
        de: {
          locale: German,
          altFormat: 'd.m.Y'
        }
      }

      const options = {
        ...localization[this.$i18n.locale],

        // Buying tickets in the past is not possible
        minDate: 'today',
        maxDate: this.maxDate,

        altInput: true
      }

      this.flatpickr = flatpickr(this.$refs.input, options)

      // The original input will be transformed to a hidden one,
      // so we need the ID on the new user-facing input.
      this.$refs.input.id = ''
      this.flatpickr.altInput.id = this.formID
    }
  }
}
</script>

<style lang="scss">
@import "../css/variables";

.form-input__input--date {
  cursor: pointer;
}

.flatpickr-prev-month,
.flatpickr-next-month {
  &:hover {
    svg {
      fill: $color-primary;
    }
  }
}

.flatpickr-day {
  &.today {
    border-color: $color-secondary;

    &:hover,
    &:focus {
      background-color: $color-secondary;
      border-color: $color-secondary;
    }
  }

  &.selected {
    background-color: $color-primary;
    border-color: $color-primary;

    &:hover,
    &:focus {
      background-color: $color-primary-dark;
      border-color: $color-primary-dark;
    }
  }
}
</style>
